define.alias("ember-math-helpers/helpers/add", "media/helpers/add");